/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { inviteListItemSchema } from "../inviteListItemSchema.ts";
import { z } from "zod/v4";

/**
 * @description Payload of Array of InviteListItem
 */
export const listInvites200Schema = z.array(z.lazy(() => inviteListItemSchema));

/**
 * @description No description
 */
export const listInvites401Schema = z.any();

/**
 * @description No description
 */
export const listInvites403Schema = z.any();

export const listInvitesQueryResponseSchema = z.lazy(
  () => listInvites200Schema,
);
